/* tslint:disabled */
/* eslint-disable */
/**
 * Report Manager
 * The service allows to request reports, download, update and delete them.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ReportTypeEnum {
  Unknown = 'UNKNOWN',
  UnusedAccessRoleSummary = 'UNUSED_ACCESS_ROLE_SUMMARY',
  UnusedAccessRoleByServiceSummary = 'UNUSED_ACCESS_ROLE_BY_SERVICE_SUMMARY',
  UnusedAccessRoleByPrivilegeSummary = 'UNUSED_ACCESS_ROLE_BY_PRIVILEGE_SUMMARY',
  UnusedAccessIdentitySummary = 'UNUSED_ACCESS_IDENTITY_SUMMARY',
  UnusedAccessIdentityByServiceSummary = 'UNUSED_ACCESS_IDENTITY_BY_SERVICE_SUMMARY',
  UnusedAccessIdentityByPrivilegeSummary = 'UNUSED_ACCESS_IDENTITY_BY_PRIVILEGE_SUMMARY',
  UnusedAccessIdentityWithoutRoleSummary = 'UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_SUMMARY',
  UnusedAccessIdentityWithoutRoleByServiceSummary = 'UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_SERVICE_SUMMARY',
  UnusedAccessIdentityWithoutRoleByPrivilegeSummary = 'UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_PRIVILEGE_SUMMARY'
}

export function ReportTypeEnumFromJSON(json: any): ReportTypeEnum {
  return json as ReportTypeEnum
}

export function ReportTypeEnumToJSON(value?: ReportTypeEnum): any {
  return value as any
}
